<template>
  <TimeEntriesTable
    :data="timeEntries"
    :loading="isLoading"
    class="flex-1"
  />
</template>
<script lang="ts" setup>
// Utils
import { computed, ref, watch } from "vue";

// Components
import TimeEntriesTable from "@/modules/time/components/TimeEntriesTable.vue"

// Composables
import { useStore } from "vuex"
const store = useStore()

const loading = computed(() => {
  return store.state.time.timeEntriesLoading
})

const isLoading = ref(true)

watch(() => loading.value, (value) => {
  isLoading.value = value
}, { immediate: true })

const timeEntries = computed(() => {
  if (isLoading.value) {
    return []
  }

  return store.getters['time/currentTimeEntries'] || []
})
</script>
